module.exports = __webpack_public_path__ + "static/media/bbva.bd607c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/bbva.png
// module id = 1986
// module chunks = 0